import React, { createContext, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { getTariffs, createTariff, updateTariff, deleteTariff } from '../services/api';

export const TariffContext = createContext();

export const TariffProvider = ({ children }) => {
  const [tariffs, setTariffs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchTariffs = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getTariffs();
      setTariffs(response.data);
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در دریافت تعرفه‌ها';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const addTariff = useCallback(async (tariffDto) => {
    setLoading(true);
    setError(null);
    try {
      const response = await createTariff(tariffDto);
      setTariffs((prev) => [...prev, response.data]);
      toast.success('تعرفه با موفقیت اضافه شد');
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.status === 400 && err.response.data.includes('حداکثر ۳ تعرفه')
          ? 'حداکثر ۳ تعرفه قابل ثبت است'
          : err.response?.data?.message || 'خطا در افزودن تعرفه';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const editTariff = useCallback(async (id, tariffDto) => {
    setLoading(true);
    setError(null);
    try {
      const response = await updateTariff(id, tariffDto);
      setTariffs((prev) =>
        prev.map((tariff) => (tariff.id === id ? response.data : tariff))
      );
      toast.success('تعرفه با موفقیت به‌روزرسانی شد');
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در به‌روزرسانی تعرفه';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const removeTariff = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      await deleteTariff(id);
      setTariffs((prev) => prev.filter((tariff) => tariff.id !== id));
      toast.success('تعرفه با موفقیت حذف شد');
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در حذف تعرفه';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <TariffContext.Provider
      value={{
        tariffs,
        loading,
        error,
        fetchTariffs,
        addTariff,
        editTariff,
        removeTariff,
      }}
    >
      {children}
    </TariffContext.Provider>
  );
};